import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export default function AfmDiffComponent() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        minHeight: "10rem",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography>
        {t("Ο ΑΦΜ από το μητρώο του ΓΕΜΗ δεν εντοπίζεται στο μητρώο της ΑΑΔΕ.")}
      </Typography>
    </Box>
  );
}
